import { render, staticRenderFns } from "./NewCriticismEndorsement.vue?vue&type=template&id=513badfe"
import script from "./NewCriticismEndorsement.vue?vue&type=script&lang=js"
export * from "./NewCriticismEndorsement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports